export var RemoteStatus;
(function (RemoteStatus) {
    RemoteStatus["Unloaded"] = "UNLOADED";
    RemoteStatus["Loading"] = "LOADING";
    RemoteStatus["Loaded"] = "LOADED";
    RemoteStatus["Failed"] = "FAILED";
})(RemoteStatus || (RemoteStatus = {}));
//# sourceMappingURL=Remote.js.map